import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";

//import Home from "../views/Home.vue";
import Home from "../components/PublicViews/HomePage/Home.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import ListingRegister from "../views/SellerRegister.vue";
import BuyerRegister from "../views/BuyerRegister.vue";
import ManageRegister from "../views/ManageRegister.vue";
import VerifyEmail from "../views/VerifyEmail.vue";
import checkEmail from "../views/CheckEmail.vue";
import VerifyMessage from "../views/VerifyMessage.vue";
import store from "../store";

import Contact from "../views/Contact.vue";
import ContactHouse from "../views/ContactHouse.vue";
import ContactBuy from "../views/ContactBuy.vue";
import News from "../views/News.vue";
import Post from "../views/Post.vue";
import Rentals from "../views/Rentals.vue";
import Rental from "../views/Rental.vue";
import Listing from "../views/Listing.vue";
import Listings from "../views/Listings.vue";
import Residents from "../views/Residents.vue";
import Resident from "../views/Resident.vue";
import Client from "../views/Client.vue";
import Reviews from "../views/Reviews/Reviews.vue";

import SingleIDX from "../views/SingleHomeView.vue";
// admin views

import Posts from "../views/Admin/Posts.vue";
import Inventory from "../views/Admin/Inventory.vue";
import ManageInventory from "../views/Admin/ManageInventory.vue";
import Messages from "../views/Admin/Messages.vue";
import Snapshots from "../views/Admin/Snapshots.vue";
import Profile from "../views/Admin/Profile.vue";
import Documents from "../views/Admin/Documents.vue";
import Clients from "../views/Admin/Clients.vue";
import Crm from "../views/Admin/CRM.vue";
import ContactCrm from "../views/Admin/crm/ContactManagement.vue";
import Receipt from "../views/Admin/Receipt.vue";
import SmsReceipt from "../views/Admin/SmsReciept.vue";
// import Idx from "../views/Admin/IDX.vue";
import CrmMessage from "../views/Admin/CrmMessage.vue";

import GeolocationIndex from "../views/Admin/GeolocationIndex.vue";
import BuyerDashboard from "../views/Clients/Home.vue";
import BuyerClientProfile from "../views/Clients/ContentDisplays/Buyer-Client-Profile.vue";

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    props: { default: true }
  },

  {
    path: "/verify/message",
    name: "VerifyMessage",
    component: VerifyMessage
  },

  {
    path: "/checkEmail",
    name: "checkEmail",
    component: checkEmail
  },

  {
    path: "/register",
    name: "Register",
    component: Register,
    props: true
  },

  {
    path: "/listing/register",
    name: "listingRegister",
    component: ListingRegister,
    props: true
  },

  {
    path: "/buyer/register",
    name: "BuyerRegister",
    component: BuyerRegister,
    props: true
  },

  {
    path: "/manage/register",
    name: "ManageRegister",
    component: ManageRegister,
    props: true
  },

  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    props: true
  },

  {
    path: "/contactForm",
    name: "ContactHouse",
    component: ContactHouse
  },

  {
    path: "/buyer/:id",
    name: "contactListing",
    component: ContactBuy
  },

  {
    path: "/news",
    name: "News",
    component: News
  },

  {
    path: "/reviews",
    name: "Reviews",
    component: Reviews
  },

  {
    path: "/residents",
    name: "Resident",
    component: Resident
  },

  {
    path: "/clients",
    name: "Client",
    component: Client
  },

  {
    path: "/news/:id",
    name: "Post",
    component: Post
  },

  {
    path: "/rentals",
    name: "rentals",
    component: Rentals
  },

  {
    path: "/residents",
    name: "residents",
    component: Residents
  },

  {
    path: "/rental/:id",
    name: "Rental",
    component: Rental
  },

  {
    path: "/listing/:id",
    name: "listing",
    component: Listing
  },

  {
    path: "/listings",
    name: "listings",
    component: Listings
  },

  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: BuyerDashboard,
    meta: { requiresAuth: true }
  },

  {
    path: "/dashboard/profile",
    name: "BuyerProfile",
    component: BuyerClientProfile,
    meta: { requiresAuth: true }
  },

  {
    path: "/all/emailReceipts",
    name: "Receipt",
    component: Receipt,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/all/smsReceipts",
    name: "SmsReceipt",
    component: SmsReceipt,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/manage/blogs",
    name: "ManageBlogs",
    component: Posts,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/verify/email",
    name: "verifyEmail",
    component: VerifyEmail,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/documents",
    name: "Documents",
    component: Documents,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/manage/clients",
    name: "Clients",
    component: Clients,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/inventory",
    name: "inventory",
    component: Inventory,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/manage/inventory",
    name: "manage-inventory",
    component: ManageInventory,
    meta: { requiresAuth: true, admin: true, RandCRM: true }
  },

  {
    path: "/messages",
    name: "messages",
    component: Messages,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/snapshots",
    name: "snapshots",
    component: Snapshots,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/crm",
    name: "CRM",
    component: Crm,
    meta: { requiresAuth: true, admin: true, RandCRM: true, GOP: true }
  },

  {
    path: "/crm/contacts",
    name: "CrmContacts",
    component: ContactCrm,
    meta: { requiresAuth: true, admin: true, RandCRM: true, GOP: true }
  },

  {
    path: "/geolocation/index",
    name: "GeolocationIndex",
    component: GeolocationIndex,
    meta: { requiresAuth: true, admin: true }
  },

  {
    path: "/crm/:id",
    name: "CrmMessage",
    component: CrmMessage,
    meta: { requiresAuth: true, admin: true, RandCRM: true }
  },

  // {
  //   path: "/idx",
  //   name: "IDX",
  //   component: Idx,
  //   meta: { requiresAuth: true }
  // },

  {
    path: "/single/:id",
    name: "SingleIDX",
    component: SingleIDX
  },

  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.name + " - HomesBy360";
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.userAuth && localStorage.userRole == "") {
      next({
        name: "Login"
      });
    } else if (
      to.matched.some(record => record.meta.admin) ||
      to.matched.some(record => record.meta.RandCRM) ||
      to.matched.some(record => record.meta.GOP)
    ) {
      // this route requires auth, check if logged in
      // if not, redirect to home page.
      if (
        localStorage.userRole === "admin" ||
        localStorage.userRole === "RandCRM" ||
        localStorage.userRole === "GOP"
      ) {
        next();
      } else {
        next({
          name: "Home"
        });
      }
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(route => route.meta.requiresAuth)) {
//     if (!store.state.auth) {
//       next("/");
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;
